package com.devi3east.bashbuddy.search.ui.components

import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable

@Composable
fun MonthFilterSheet(
    onApply: (Int) -> Unit,
    onDismiss: () -> Unit
) {

    val months = listOf(
        "January","February","March","April","May","June",
        "July","August","September","October","November","December"
    )

    FilterBottomSheet(
        title = "Select Month",
        onDismiss = onDismiss
    ) {
        months.forEachIndexed { index, name ->
            TextButton(
                onClick = { onApply(index + 1) },
            ) {
                Text(name)
            }
        }
    }
}